import Swiper from 'swiper';
import SectionTitleReveal from '../common/section-title-reveal';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation, Pagination } from 'swiper/modules';
import { bindSwiperNavigationA11y } from '../common/syncSwiperNavigationA11y';

export default class LastNewsList {

    constructor() {
        this.sections = document.querySelectorAll('.block-last-news-list');
        this.ready();
    }

    ready() {
        this.sections.forEach(section => {
            const slider = section.querySelector('.swiper');
            if (!slider) return;

            const navigationNext = section.querySelector('.last-news-navigation .slider-button-next');
            const navigationPrev = section.querySelector('.last-news-navigation .slider-button-prev');
            const pagination = section.querySelector('.last-news-navigation .swiper-pagination');

            const swiperInstance = new Swiper(slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                spaceBetween: 24,
                watchSlidesProgress: true,
                navigation: navigationNext && navigationPrev ? {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                } : false,
                pagination: pagination ? {
                    el: pagination,
                    clickable: true,
                } : false,
                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                        allowTouchMove: false,
                    },
                },
            });

            bindSwiperNavigationA11y(swiperInstance);
        });
    }
}

new SectionTitleReveal('.block-last-news-list');

if (document.querySelector('.block-last-news-list')) {
    new LastNewsList();
}
